var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRub = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 0.0996094C9.22713 0.0996094 11.8483 2.69097 11.8984 5.90625H0.101562C0.151654 2.69096 2.77276 0.0996096 6 0.0996094Z",
  fill: "white",
  stroke: "#CECECE",
  strokeWidth: 0.2
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 6.00635H11.9998C11.9964 9.31708 9.31148 11.9999 5.99992 11.9999C2.68827 11.9999 0.00343797 9.31708 0 6.00635Z",
  fill: "#D52B1E"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0.345016 3.99121H11.655C11.8781 4.61925 12 5.29531 12 5.99995C12 6.70934 11.8766 7.38986 11.6505 8.02156H0.349508C0.123434 7.38986 0 6.70934 0 5.99995C0 5.29531 0.121881 4.61925 0.345016 3.99121Z",
  fill: "#0039A6"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rub.c34bf8b44922c9a66e809611aa87d43e.svg";